import { devStorage } from '@/configs/storages';

if (devStorage.getItem('debugLevel') === null) {
  devStorage.setItem(
    'debugLevel',
    import.meta.env.VITE_CONFIG_DEBUG ? Number(import.meta.env.VITE_CONFIG_DEBUG) : 2
  );
}

export type DebugLevel = 0 | 1 | 2;

export function setDebugLevel(level: DebugLevel) {
  devStorage.setItem('debugLevel', level);
  location.reload();
}

export const debugLevel = devStorage.getItem('debugLevel');
